module.exports = __webpack_public_path__ + "img/blue_104.7d546ed8.png";